module.exports = __webpack_public_path__ + "static/media/masthead-mobile.2dd61fb9.png";